import React, { createContext, useContext, useState } from 'react';
import { authLogin } from '../services/api';

interface AuthContextType { isAuthenticated: boolean; token: string | null; login: (u: string, p: string) => Promise<boolean>; logout: () => void; }
const AuthContext = createContext<AuthContextType>({ isAuthenticated: false, token: null, login: async () => false, logout: () => {} });

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [token, setToken] = useState<string | null>(() => localStorage.getItem('nidave-token'));

  const login = async (username: string, password: string): Promise<boolean> => {
    try {
      const res = await authLogin(username, password);
      const t = res.data.token;
      setToken(t);
      localStorage.setItem('nidave-token', t);
      return true;
    } catch (error) {
      return false;
    }
  };

  const logout = () => {
    setToken(null);
    localStorage.removeItem('nidave-token');
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated: !!token, token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);